import { render, staticRenderFns } from "./FacilityCreateName.vue?vue&type=template&id=0dae5409&"
import script from "./FacilityCreateName.vue?vue&type=script&lang=js&"
export * from "./FacilityCreateName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports